import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import _ from "lodash";
export function cn() {
    var inputs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        inputs[_i] = arguments[_i];
    }
    return twMerge(clsx(inputs));
}
/**
 *
 * @param {Array} arr -> [{key, value}, {key, value}, etc]
 * @returns Object -> {key: value}
 */
export var convertArrayToObject = function (arr) {
    if (arr === void 0) { arr = []; }
    if (!Array.isArray(arr)) {
        console.log("[ERROR] given input is not an Array");
        return {};
    }
    return arr.reduce(function (acc, curr) {
        acc[curr.key] = curr.value;
        return acc;
    }, {});
};
export function isFiniteNumber(value) {
    return Number.isFinite(value);
}
/**
 * Column configuration mapping.
 *
 * Example:
 * {
 *   "Estimated Price": {
 *     visibleFor: ["PA", "EA", "EU"],
 *     valueKey: "Estimated",
 *     condition: true
 *   },
 *   "Final Price": {
 *     valueKey: "Final",
 *     condition: false
 *   },
 *   "Reversed Units": {
 *     visibleFor: ["PA", "EA", "EU"],
 *     valueKey: ["Reversed", "Adjusted"],
 *     fun: (reversed, adjusted) => `${reversed} / ${adjusted}`
 *   }
 * }
 *
 * @typedef {Object.<string, {
 *   visibleFor?: string[],          // Roles that can see the column
 *   valueKey: string | string[],    // Key(s) from the row object to use
 *   condition?: boolean,            // Whether the column should be displayed
 *   fun?: (...args: any[]) => any   // Custom function to compute value when multiple keys are given
 * }>} ColMap
 */
/**
 * Filters and maps column configuration based on user role.
 *
 * @param {ColMap} colMap - The column configuration map.
 * @param {string} loggedInRole - The role of the logged-in user (e.g., "EA", "PA", "EU").
 * @returns {Object.<string, {
 *   getValue: (row: Object, defaultVal?: any) => any,
 *   original: any
 * }>} A mapping of visible column names to:
 *   - `getValue`: function to extract or compute the column value from a row.
 *   - `original`: the original column configuration object.
 */
export function getTableCol(colMap, loggedInRole) {
    try {
        if (!loggedInRole)
            throw new Error("\"loggedInRole\" is required");
        if (!colMap)
            throw new Error("\"colMap\" is required");
        var _r_1 = loggedInRole;
        var _v_1 = ["PA", "EA", "EU", "ESU"]; // defaultVisibility
        var column = Object.keys(colMap);
        var result = column
            .filter(function (key) {
            var col = _.get(colMap, key, {});
            var condition = _.get(col, "condition", true);
            var visibility = _.get(col, "visibleFor", _v_1).includes(_r_1);
            return condition && visibility;
        })
            .reduce(function (acc, cur) {
            var mObj = colMap[cur];
            acc[cur] = {
                getValue: function (ele, defaultVal) {
                    var _a;
                    if (defaultVal === void 0) { defaultVal = "-"; }
                    var keys = mObj.valueKey;
                    if (typeof keys === "string")
                        return (_a = ele[keys]) !== null && _a !== void 0 ? _a : defaultVal;
                    if (Array.isArray(keys)) {
                        if (typeof mObj.fun === "function") {
                            var valArr = keys.map(function (_k) { var _a; return (_a = ele[_k]) !== null && _a !== void 0 ? _a : ""; });
                            return mObj.fun.apply(mObj, valArr);
                        }
                    }
                    return defaultVal;
                },
                original: mObj,
            };
            return acc;
        }, {});
        return result;
    }
    catch (error) {
        console.log("[ERROR][getTableCol] not able to filter", error);
        return {};
    }
}
